module.exports = __webpack_public_path__ + "static/media/AttitudeIcon.060f3109.svg";